import { render, staticRenderFns } from "./View.vue?vue&type=template&id=0899ebc4&scoped=true&lang=html&"
import script from "./View.vue?vue&type=script&lang=js&"
export * from "./View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0899ebc4",
  null
  
)

export default component.exports